import o from"styled-components";import{theme as i}from"../../../../../theme.js";const e=o.div`
  padding: ${i.spacing*4}px;
  border-radius: ${i.radius}px;
  background-color: ${i.colors.gray[100]};
  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .title {
      font-size: 14px;
      line-height: 21px;
      color: ${i.colors.gray[500]};
      font-weight: 700;
    }
    .arrow-button {
      border: none;
      outline: none;
      width: 40px;
      height: 40px;
      padding: 0;
      margin: 0;
      border-radius: 50%;
      background-color: transparent;
      transition: all .1s ease-in-out;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      > svg {
        width: 24px;
        height: 24px;
        transform: rotate(180deg);
        > g, path {
          fill: ${i.colors.gray[400]}
        }
      }
      &:hover {
        background-color: ${i.colors.gray[200]};
        > svg {
          > g, path {
            fill: ${i.colors.gray[500]};
          }
        }
      }
    }
  }
  .tags {
    display: flex;
    flex-wrap: wrap;
    gap: ${i.spacing*3}px;
    align-items: center;
    margin-top: ${i.spacing*4}px;
    .label {
      font-size: 12px;
      line-height: 14px;
      color: ${i.colors.gray[500]};
    }
  }
`,n=o.div`
  display: flex;
  flex-direction: column;
  gap: ${i.spacing*4}px;
  padding: ${i.spacing*4}px;
  height: fit-content;
  box-sizing: border-box;
  @media screen and (max-width: ${i.breakpoints.md}) {
    padding: ${i.spacing*4}px;
  }
`,a=o.div`
  color: ${({color:r})=>r};
  background-color: ${i.colors.primary[50]};
  border-radius: ${i.radius}px;
  padding: ${i.spacing}px ${i.spacing*2}px;
  display: flex;
  align-items: center;
  gap: ${i.spacing}px;
  > svg {
    width: 14px;
    height: 14px;
  }
  > span {
    font-size: 12px;
    font-weight: 700;
    color: ${i.colors.primary[500]};
  }
`;export{n as Container,a as FeelingContainer,e as OptionContainer};
